import { tenantSettingsSerializer } from '@/providers/serializers/tenant-settings/tenant-settings';
import {Vue} from 'vue-property-decorator';
import { http } from '../http';

export class TenantSettingsAPI extends Vue {

    public static INSTANCE = new TenantSettingsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/missioncontrol/v1';

    private categorynamespace: string = 'api/nucleus/v2/taxonomy';

    private adminNamespace: string = 'api/admin/v1';

    public fetchActiveTenantSettings(token?: any) {
        const endpoint = `api/nucleus/v1/lookups/tenant-settings`;
        const header = http.getTokenHeaders(token);
        return http.get(endpoint, header).then((response) => {
            return tenantSettingsSerializer.serializeActiveTenantSettings(response.data);
        });
    }
}

export const tenantSettingsAPI = TenantSettingsAPI.instance;
